export function multilingualFields(fieldNames, defaultValue = null, locales = ['uk', 'ru', 'en']) {
    return fieldNames.reduce((acc, field) => {
        // eslint-disable-next-line no-return-assign
        locales.forEach(localeName => acc[`${field}:${localeName}`] = defaultValue)

        return acc
    }, {})
}

export const localizeField = (fieldName, currentLocale) => `${fieldName}:${currentLocale}`

export function multilingualFieldKeys(fieldNames, locales = ['uk', 'ru', 'en']) {
    return fieldNames.reduce((acc, field) => {
        locales.forEach(localeName => acc.push(`${field}:${localeName}`))

        return acc
    }, [])
}
